// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import InvoicesController from "./invoices_controller"
application.register("invoices", InvoicesController)

import MeterFormController from "./meter_form_controller"
application.register("meter-form", MeterFormController)

import ReadingsController from "./readings_controller"
application.register("readings", ReadingsController)

import TariffRowController from "./tariff_row_controller"
application.register("tariff-row", TariffRowController)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)
